import script from "./errorNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./errorNotice.vue?vue&type=script&setup=true&lang=ts"

import "./errorNotice.vue?vue&type=style&index=0&id=e3398084&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3398084"]])

export default __exports__